import { render, staticRenderFns } from "./EventDisplayMode.vue?vue&type=template&id=c13f28bc&scoped=true"
import script from "./EventDisplayMode.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventDisplayMode.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventDisplayMode.vue?vue&type=style&index=0&id=c13f28bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13f28bc",
  null
  
)

export default component.exports